import {
  PARTNER_SPECIFIC_IBAN,
  CONTACT_PERSON_FIRST_NAME,
  CONTACT_PERSON_GENDER,
  CONTACT_PERSON_LAST_NAME,
  BFS_CUSTOMER_TYPE,
} from 'modules/Inquiry/Form/formFields';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';
import { InquiryConstants } from 'schema/inquirySchema.constants';

export const bfsContactPersonfieldValidation = {
  [CONTACT_PERSON_GENDER]: fieldValidators.string().required(),
  [CONTACT_PERSON_FIRST_NAME]: fieldValidators
    .string()
    .required()
    .max(InquiryConstants.MAX_END_USER_FIRST_NAME),
  [CONTACT_PERSON_LAST_NAME]: fieldValidators
    .string()
    .required()
    .max(InquiryConstants.MAX_END_USER_LAST_NAME),
};

export const bfsCompanyDetailsFieldValidation = {
  // EBS-38: "Kontonummer bei der SozialBank" = the last 10 digits of the IBAN,
  // i.e. exactly 10 numeric digits (numeric via .number, exact length via .length).
  [PARTNER_SPECIFIC_IBAN]: fieldValidators.maxLength().number(10).length(10),
  [BFS_CUSTOMER_TYPE]: fieldValidators.string().required(),
};
